import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import React from 'react';
import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';
import { CreateButton } from '../../common/elements/Form';

const pageWidth = `
  width: 100%;
  max-width: ${layout.contentMaxWidth};
  margin-left: auto;
  margin-right: auto;
`;

export const InboxHeader = styled.header`
  ${pageWidth}
  padding: ${space[5]} ${layout.gutter} ${space[4]};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: ${space[3]};

  ${media.md`
    padding: ${space[6]} ${layout.gutterWide} ${space[5]};
  `}
`;

export const InboxTitle = styled.h1`
  font-size: ${fontSize.xxl};
  font-weight: ${fontWeight.heavy};
  line-height: ${lineHeight.tight};
  margin: 0;
  color: ${({ theme }) => theme.headerColour};

  ${media.md`
    font-size: ${fontSize.display};
  `}
`;

export const PreviewsList = styled.ul`
  ${pageWidth}
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  margin-top: 0;
  margin-bottom: 0;
  padding: 0 ${layout.gutter} ${space[6]};
  list-style: none;

  ${media.md`
    padding: 0 ${layout.gutterWide} ${space[7]};
  `}
`;

export const CreateMessageButton = styled(CreateButton).attrs(({ $size }) => ({
  $size: $size || 'sm',
}))``;

export const CreateMessagePlusIcon = (props) => (
  <AddCircleOutlineIcon style={{ fontSize: fontSize.xl }} {...props} />
);

export const InboxPlaceholder = styled.p`
  color: ${neutral.textMuted};
  background: ${neutral.surface};
  border: 1px dashed ${neutral.borderStrong};
  border-radius: ${radius.lg};
  margin: 0;
  padding: ${space[6]} ${space[5]};
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.semibold};
  line-height: ${lineHeight.normal};
  text-align: center;
`;
